import { render, staticRenderFns } from "./WithReviewButtonBlock.vue?vue&type=template&id=204b737e&"
import script from "./WithReviewButtonBlock.vue?vue&type=script&lang=js&"
export * from "./WithReviewButtonBlock.vue?vue&type=script&lang=js&"
import style0 from "./WithReviewButtonBlock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports